import React from 'react';

const Home: React.FC = () => {
  return (
    <main>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <img 
            src="/images/bounce_image_1.JPG" 
            alt="Bounce Fit Dubai" 
            className="hero-image"
            style={{ objectPosition: 'top' }}
          />
          <div className="hero-center">
            <img 
              src="/images/bounce_banner.png" 
              alt="Bounce Fit Dubai" 
              className="hero-banner"
            />
            <p className="hero-text">Resistance-based fitness classes, choreographed to banging tunes.</p>
            <a href="https://bookwhen.com/bouncefitdubai" target="_blank" rel="noopener noreferrer" className="button">
              Book
            </a>
          </div>
          <img 
            src="/images/bounce_image_2.JPG" 
            alt="Bounce Fit Dubai" 
            className="hero-image"
            style={{ objectPosition: 'center' }}
          />
        </div>
      </section>

      {/* About Section */}
      <section className="section">
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div>
            <h2 className="section-title" style={{ color: 'var(--primary-color)' }}>About ((BOUNCE))</h2>
            <p>
              Bounce Fit Dubai brings you professional rebound fitness classes, licensed by Bounce Fit Body. Our high-energy workouts combine cardio, strength training, and fun on mini trampolines.
            </p>
            <p>
              Whether you're looking to improve your health, fitness, or just have fun while exercising, our classes are designed for all fitness levels.
            </p>
          </div>
        </div>

        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div>
            <h2 className="section-title" style={{ color: 'var(--primary-color)' }}>About ((B)) Pilates</h2>
            <p>
              Our unique body flow class on trampolines includes elements of yoga and pilates highlighting strength, tone and flexibility. This challenging session is full of balancing, hold and contracting moves to test core strength while still incorporating bouncing routines. 
            </p>
            <p>
              Ideal for anyone who likes a little zen in their workout. 
            </p>
          </div>
        </div>
      </section>

      <section className="section">

      </section>

      {/* Benefits Section */}
      <section className="section" style={{ background: '#40E0D0' }}>
        <div className="container">
          <h2 className="section-title" style={{ color: 'var(--primary-color)', background: 'transparent' }}>Why Choose ((BOUNCE))?</h2>
          <div className="grid grid-3">
            <div className="card">
              <h3>Low Impact</h3>
              <p>Gentle on joints while providing an effective workout</p>
            </div>
            <div className="card">
              <h3>Full Body Workout</h3>
              <p>Engages all major muscle groups for complete fitness</p>
            </div>
            <div className="card">
              <h3>Fun & Social</h3>
              <p>Enjoyable group atmosphere that keeps you motivated</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home; 